import notSet from './notSet';
import isEmail from './isEmail';

export default (val, field) => {
    if (notSet(val)) {
        return null;
    }

    switch (field) {
        case 'newPassword':
            if (val.length < 6) {
                return 'Password must have at least 6 characters';
            }
            break;
        case 'firstName':
            if (val.length < 2) {
                return 'Enter a first name with at least 2 characters';
            }
            break;
        case 'lastName':
            if (val.length < 2) {
                return 'Enter a last name with at least 2 characters';
            }
            break;
        case 'email':
            if (!isEmail(val)) {
                return 'Double check your email it doesn’t look valid to us';
            }
            if (/\.con$/.test(val)) {
                return 'Looks like you put .con did you mean .com?';
            }
            break;
        case 'zipcode':
            if (!/^[a-zA-Z0-9\-_]{1,25}$/.test(val)) {
                return 'Please enter a valid Postal Code';
            }
            break;
        default:
    }

    return null;
};



/** WEBPACK FOOTER **
 ** ./src/utils/managedValidator.js
 **/